// export const HOST = 'https://test.mwork365.cloud';
export const HOST = '';

export const MAIN_API_ROOT = `${HOST}/main/api`;
export const MAIN_IMAGE_ROOT = `${HOST}/main`;
export const NOTIFICATIONS_ROOT = `${HOST}/notifications`;
// mWork365.WebApi (modular monolith — Statistics module, audit, …) behind YARP `/api`.
export const API_V2 = `${HOST}/api`;

export const LOCAL_TRANSLATION_ROOT = `/translations`;
export const PRODUCTION_TRANSLATION_ROOT = 'https://translations.mwork365.com';
